// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__2C66e","line":"Grid_line__QhmvZ","horizontal":"Grid_horizontal__3YNA8","vertical":"Grid_vertical__jsOkc"};